import { skipToken, useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

import { edictsApi } from "@/api";
import { QueryKey } from "@/query/Query";

import { EdictSearchParams } from "../Edicts.types";

const QUERY_DATE_FORMAT = "yyyy-MM-dd";

// A quarter of an hour of switching between the registers keeps both results; the source is part of the key,
// so each register's search run is cached on its own.
const EDICTS_CACHE_TIME_MS = 15 * 60 * 1000;

export function edictsQueryKey(params: EdictSearchParams | null) {
  return [
    QueryKey.Edicts,
    params?.source,
    params ? format(params.from, QUERY_DATE_FORMAT) : null,
    params ? format(params.to, QUERY_DATE_FORMAT) : null,
  ];
}

export function useEdictsQuery(params: EdictSearchParams | null) {
  return useQuery({
    queryKey: edictsQueryKey(params),
    queryFn:
      params === null
        ? skipToken
        : () => edictsApi.getEdicts({ source: params.source, from: params.from, to: params.to }),
    // A search run is user-triggered and can run for minutes against the register; retrying would only
    // multiply the wait before the failure reaches the staff member, who can simply start it again.
    retry: false,
    // A search run happens only when it is asked for: without this, coming back to the tab or remounting would
    // silently start another minutes-long register call behind an already-populated table.
    staleTime: Infinity,
    gcTime: EDICTS_CACHE_TIME_MS,
  });
}
